export default __webpack_public_path__ + "static/media/nuclearjs.dbbb5b5f.svg";